<div class="conn-card">
    <app-report-top-filter-bar *ngIf="1==1"
        [paraReportName]="'daily-money-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
    ></app-report-top-filter-bar>

    <div class="grid dmr-kpi-grid" *ngIf="dataList.length>0">
        <div class="col-12 sm:col-6 md:col-4">
            <div class="dmr-kpi">
                <div class="dmr-kpi-label">Total Invoices</div>
                <div class="dmr-kpi-value">{{dataList[0].totalInvoices | number}}</div>
            </div>
        </div>
        <div class="col-12 sm:col-6 md:col-4">
            <div class="dmr-kpi">
                <div class="dmr-kpi-label">Avg. Ticket</div>
                <div class="dmr-kpi-value">{{dataList[0].avgTicket | currency | currencySpacing}}</div>
            </div>
        </div>
        <div class="col-12 sm:col-6 md:col-4">
            <div class="dmr-kpi-s">
                <div class="dmr-kpi-label">Total Sales</div>
                <div class="dmr-kpi-value">{{dataList[0].totalGrossSales | currency | currencySpacing}}</div>
            </div>
        </div>
    </div>

    <div class="dmr-sections" *ngIf="dataList.length>0">
        <div class="dmr-section" *ngFor="let section of sectionSummaries">
            <button type="button" class="dmr-section-header"
                [attr.aria-expanded]="section.expanded"
                (click)="section.expanded = !section.expanded">
                <i class="pi dmr-caret" [ngClass]="section.expanded ? 'pi-caret-down' : 'pi-caret-right'"></i>
                <span class="dmr-section-title">{{section.heading}}</span>
                <!-- <span class="dmr-section-lines">{{section.lines}} lines</span> -->
                <span class="dmr-section-total">{{section.total}}</span>
            </button>
            <div class="dmr-section-body" *ngIf="section.expanded">
                <div class="dmr-row" *ngFor="let x of section.rows" [class.dmr-row-zero]="x.isZero">
                    <span class="dmr-row-label">{{x.name}}</span>
                    <span class="dmr-row-value">{{x.value}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="flex" *ngIf="dataList?.length==0">
        <div class="flex justify-content-center" style="width: 100%">
            <span class="control-description text-muted text-align-center"> No data found!</span>
        </div>
    </div>
</div>
